import { Question } from '@trustero/trustero-api-web/lib/questionnaire/questionnaire_pb'
import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

type CurrentQuestionContextType = {
  question: Question
  setCurrentQuestion: (() => void) | Dispatch<SetStateAction<Question>>
  questionnaireId: string
  setCurrentQuestionnaireId: (() => void) | Dispatch<SetStateAction<string>>
}

const CurrentQuestionContext = createContext<CurrentQuestionContextType>({
  question: new Question(),
  setCurrentQuestion: () => undefined,
  questionnaireId: '',
  setCurrentQuestionnaireId: () => undefined,
})

export const useCurrentQuestion = (): CurrentQuestionContextType => {
  return useContext(CurrentQuestionContext)
}

type CurrentQuestionProviderProps = {
  children: React.ReactNode
}

export const CurrentQuestionProvider = ({
  children,
}: CurrentQuestionProviderProps): JSX.Element => {
  const [question, setCurrentQuestion] = useState<Question>(new Question())
  const [questionnaireId, setCurrentQuestionnaireId] = useState('')

  return (
    <CurrentQuestionContext.Provider
      value={{
        question,
        setCurrentQuestion,
        questionnaireId,
        setCurrentQuestionnaireId,
      }}
    >
      {children}
    </CurrentQuestionContext.Provider>
  )
}
